module.exports = __webpack_public_path__ + "files/e69b9513bba6b6a563bad05e8a0de80c.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Bold.ttf
// module id = 1393
// module chunks = 59